import React from "react";
import "./exams.scss";

export const ExamCardEmpty = ({ }) => {

  return (
    <>
        <p>No results found</p>
    </>
  );
};
